import { FC } from 'react';
import { BaseTab } from '../BaseTab';
import { useTranslation } from 'react-i18next';
import useTopicAboutPageFetcher from '../../../../../common/use-topic-about-page-fetcher';
import useIframeResize from '../../../../../common/useIframeResize';
import { Container } from '@socialchorus/shared-ui-components';
import { Spinner } from '../../../../ui';
import styles from './styles.module.scss';
interface Props {
  topicId: string;
  activeTabId: number;
}

const AboutTab: FC<Props> = ({ topicId, activeTabId }) => {
  const { aboutPage, isFetching, isError } = useTopicAboutPageFetcher({
    topicId: topicId,
  });
  const { t } = useTranslation();
  const errorMessage = t('screens.topics.about.error');
  const iframeStyles = `
  body {
    margin: 0;
    padding: 1px 0;
  }
  img {
    max-width: 100%;
  }
  `;

  const modifiedAboutPage = aboutPage?.replace(
    /(<a.*?)>/g,
    '$1 target="_top">'
  );
  const { height, ref: iframeRef } = useIframeResize({
    styles: iframeStyles,
  });

  return (
    <BaseTab activeTabId={activeTabId} topicId={topicId}>
      <Container className={styles.Container}>
        {isError && !isFetching && <div>{errorMessage}</div>}
        {isFetching && <Spinner />}
        {!isFetching && (
          <iframe
            srcDoc={modifiedAboutPage}
            ref={iframeRef}
            title="about-page"
            className={styles.AboutIframe}
            style={height !== undefined ? { height: `${height}px` } : undefined}
            height={height}
            scrolling="no"
          />
        )}
      </Container>
    </BaseTab>
  );
};

export default AboutTab;
